import React from 'react'
import "./Retry.css"

function Retry(props) {
  if(props.type === "document"){
    return (
      <div className="retry__document">
        <img src="/images/Retry.png" alt="Retry" width={25} />
        <span class="material-symbols-outlined retry_error-icon">error</span>
      </div>
    )
  }
  return (
    <div className="retry__main" {...props}>Retry</div>
  )
}

export default Retry


// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/Message Components/Retry.js